import { render } from "./PortfolioPreview.vue?vue&type=template&id=3318c646&scoped=true"
import script from "./PortfolioPreview.vue?vue&type=script&lang=js"
export * from "./PortfolioPreview.vue?vue&type=script&lang=js"

import "./PortfolioPreview.vue?vue&type=style&index=0&id=3318c646&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3318c646"]])

export default __exports__